import { Injectable } from '@angular/core';
import {
    AvailableResult,
    BiometryType,
    NativeBiometric
} from '@capgo/capacitor-native-biometric';

@Injectable({
    providedIn: 'root'
})
export class BiometriaService {

    private status?: AvailableResult;

    async consultar(): Promise<AvailableResult> {
        this.status = await NativeBiometric.isAvailable({ useFallback: true });
        return this.status;
    }

    async disponivel(): Promise<boolean> {
        const status = await this.consultar();
        return status.isAvailable;
    }

    async autenticar(motivo: string = 'Confirme sua identidade para abrir o E-brigada'): Promise<boolean> {
        const status = await this.consultar();

        if(!status.isAvailable){
            return false;
        }

        try {
            await NativeBiometric.verifyIdentity({
                reason: motivo,
                title: 'E-brigada',
                subtitle: motivo,
                negativeButtonText: 'Cancelar',
                useFallback: true,
                fallbackTitle: 'Usar código do aparelho',
                maxAttempts: 1
            });

            return true;
        } catch (e) {
            return false;
        }
    }

    nome(status: AvailableResult | undefined = this.status): string {
        switch(status?.biometryType){
            case BiometryType.FACE_ID:
            case BiometryType.FACE_AUTHENTICATION:
                return 'reconhecimento facial';
            case BiometryType.TOUCH_ID:
            case BiometryType.FINGERPRINT:
                return 'impressão digital';
            case BiometryType.IRIS_AUTHENTICATION:
                return 'íris';
            case BiometryType.DEVICE_CREDENTIAL:
                return 'código do aparelho';
            default:
                return 'biometria';
        }
    }
}
